import TextCTA from './TextCTA';

export { type TextCTAProps } from './TextCTA';
export default TextCTA;
